import { useState, useRef } from "react";
import { api, formatApiError } from "@/lib/api";
import { UploadCloud, FileText, CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const PdfUpload = ({ category, value, onUploaded, testId, label, endpoint = "/upload", apiClient = api }) => {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.name.toLowerCase().endsWith(".pdf")) {
      toast.error("Only PDF files are allowed");
      return;
    }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("category", category);
      fd.append("file", file);
      const { data } = await apiClient.post(endpoint, fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data);
      toast.success("PDF uploaded");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div
      data-testid={testId}
      onClick={() => !uploading && inputRef.current?.click()}
      className={`cursor-pointer border border-dashed p-6 flex items-center gap-4 transition-colors ${
        value ? "border-[#10B981] bg-[#10B98110]" : "border-[#2A2A2A] hover:border-[#FF4D00] bg-[#050505]"
      }`}
    >
      <input ref={inputRef} type="file" accept="application/pdf,.pdf" className="hidden" onChange={handle} />
      {uploading ? (
        <Loader2 className="w-6 h-6 animate-spin text-[#FF4D00]" />
      ) : value ? (
        <CheckCircle2 className="w-6 h-6 text-[#10B981]" />
      ) : (
        <UploadCloud className="w-6 h-6 text-[#A1A1AA]" />
      )}
      <div className="min-w-0">
        <div className="text-sm text-white font-medium">{label}</div>
        <div className="text-xs text-[#A1A1AA] truncate flex items-center gap-1">
          {value ? (<><FileText className="w-3 h-3" /> {value.original_filename}</>) : "Click to upload a PDF"}
        </div>
      </div>
    </div>
  );
};
